import React from "react"
import { Flex } from "rebass"
import FlatButton from "material-ui/FlatButton"
import ViewList from "material-ui/svg-icons/action/view-list"

import { IconTitle } from "../../components"
export const HeaderTitleChart = () => {
  return (
    <Flex
      w={[1]}
      direction={["column", "row"]}
      justify={["center", "space-between"]}
    >
      <IconTitle icon="agency" title={"resources.contents.titleChart"} />
      <Flex
        px={[1]}
        pt={[1, 0]}
        align={["flex-end", "flex-start"]}
        justify={["flex-end"]}
        direction={["row"]}
        wrap
      >
        <FlatButton
          icon={<ViewList />}
          href={`#/contents`}
          label="List"
          primary={true}
        />
      </Flex>
    </Flex>
  )
}



// WEBPACK FOOTER //
// ./src/contents/chart/styled.js